import { request } from "../_helpers/Auth";

const namespace = "/api";

export const getExportProfiles = () => {
    return request({
        url: namespace + "/export-profiles",
        method: "get",
    });
};

export const getExportProfile = (id) => {
    return request({
        url: namespace + "/export-profiles/" + id,
        method: "get",
    });
};

export const getExportUserFields = () => {
    return request({
        url: namespace + "/export-profiles/user-fields",
        method: "get",
    });
};

export const createExportProfile = (payload) => {
    return request({
        url: namespace + "/export-profiles",
        data: payload,
        method: "post",
    });
};

export const updateExportProfile = (id, payload) => {
    return request({
        url: namespace + "/export-profiles/" + id,
        data: payload,
        method: "put",
    });
};

export const deleteExportProfile = (id) => {
    return request({
        url: namespace + "/export-profiles/" + id,
        method: "delete",
    });
};

export const generatePayrollExport = (id, payload) => {
    return request({
        url: namespace + "/export-profiles/" + id + "/generate",
        data: payload,
        method: "post",
        responseType: "blob",
    });
};

const USER_HEADERS = {
    last_name: "NOM",
    first_name: "PRENOM",
};

const CALC_HEADERS = {
    name: "CALCUL",
    value: "NB_JOURS",
    start_time: "DATE_DEBUT",
    end_time: "DATE_FIN",
    payroll_rubric: "RUBRIQUE",
};

const EXPORT_HEADERS = {
    start_date: "DEBUT_EXPORT",
    end_date: "FIN_EXPORT",
};

export const resolveExportColumnHeader = (value) => {
    const match = /^(user|export|calc)\.(.+)$/.exec(value || "");
    if (!match) return (value || "").toUpperCase();

    const [, prefix, key] = match;
    if (prefix === "user") {
        return USER_HEADERS[key] || key.toUpperCase();
    }
    if (prefix === "export") {
        return EXPORT_HEADERS[key] || key.toUpperCase();
    }
    return CALC_HEADERS[key] || key;
};

export const columnWithHeader = (value, position) => ({
    value,
    position,
    header: resolveExportColumnHeader(value),
});

export const defaultColumnsForLayout = (layoutMode, calculationNames = []) => {
    if (layoutMode === "one_row_per_record") {
        return [
            columnWithHeader("user.first_name", 1),
            columnWithHeader("user.last_name", 2),
            columnWithHeader("calc.name", 3),
            columnWithHeader("calc.value", 4),
            columnWithHeader("calc.start_time", 5),
            columnWithHeader("calc.end_time", 6),
            columnWithHeader("calc.payroll_rubric", 7),
        ];
    }

    return [
        columnWithHeader("user.first_name", 1),
        columnWithHeader("user.last_name", 2),
        ...calculationNames.map((name, index) =>
            columnWithHeader(`calc.${name}`, index + 3)
        ),
    ];
};

export const defaultCalculation = () => ({
    name: "CALC_CONGES",
    payroll_rubric: "",
    hour_type_ids: [],
    weekdays: [1, 2, 3, 4, 5, 6, 7],
    holiday_filter: "any",
    time_ranges: [],
    period_granularity: "export_period",
    min_duration_minutes: null,
    max_duration_minutes: null,
    result_format: "hours_cents",
});
